function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.45765 4.47126C5.86995 3.92519 5.84741 3.01786 6.40732 2.44468C6.96722 1.87151 7.89753 1.84953 8.48523 2.3956C8.48523 2.3956 17.5544 10.953 17.5791 10.9778C18.1587 11.5692 18.137 12.5068 17.5307 13.072L8.48532 21.6027C7.89855 22.1498 6.9682 22.1293 6.40732 21.5571C5.84643 20.9848 5.86741 20.0774 6.45417 19.5304L14.0917 12.2029C14.2066 12.0927 14.2066 11.909 14.0918 11.7988L6.45765 4.47126Z",
  fill: "#878793"
});

function SvgIconKeyboardArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-right.55b6f671.svg";
export { ForwardRef as ReactComponent };